import * as Sentry from '@sentry/browser'
import {BrowserTracing} from '@sentry/tracing'
import {Config} from '../../config'

Sentry.init({
	dsn             : Config.sentry.dsn,
	environment     : Config.system.environment,
	integrations    : [new BrowserTracing()],
	tracesSampleRate: Config.sentry.sample_rate,
})

require('es6-promise/auto.js')

require('../../style/vendor/tailwind.css')

window.$ = window.jQuery = require('jquery')

require('awesome-notifications/dist/style.css')
require('awesome-notifications/dist/index.var.js')

require('daterangepicker/daterangepicker.js')
require('daterangepicker/daterangepicker.css')

require('izitoast/dist/css/iziToast.min.css')
require('izitoast/dist/js/iziToast.min.js')

require('jquery-ui-dist/jquery-ui.min.css')
require('jquery-ui-dist/jquery-ui.theme.min.css')
require('jquery-ui-dist/jquery-ui.min.js')

require('lazyload/lazyload.min.js')

require('remodal/dist/remodal.css')
require('remodal/dist/remodal-default-theme.css')
require('remodal/dist/remodal.min.js')

require('swiper/swiper-bundle.min.css')
require('swiper/swiper-bundle.min.js')

window.App = {
	_common    : require('./client/_common.js').default,
	Contact    : require('./client/contact.js').default,
	Find       : require('./client/find.js').default,
	Index      : require('./client/index.js').default,
	Login      : require('./client/login.js').default,
	Recruit    : require('./client/recruit.js').default,
	Register   : require('./client/register.js').default,
	Request    : require('./client/request.js').default,
	Reservation: require('./client/reservation.js').default,
	Shop       : require('./client/shop.js').default,

	common: {
		Helper : require('../../client/helper.js').default,
		Is     : require('../../client/is.js').default,
		Log    : require('../../client/log.js').default,
		Network: require('../../client/network.js').default,
		Ui     : require('../../client/client-ui.js').default,
	},
}
